import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginServicesService } from '../services/login-services.service';
import { AuthCodeFormComponentUser } from "../utils/auth-code-form-user/auth-code-form-user.component";
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../theme.service';
import {  } from "../utils/alert-modal/alert-modal.component";
import { passwordStrengthValidator } from '../passwordValidator';
import { LoaderComponent } from "../utils/loader/loader.component";
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { InputNumberModule } from 'primeng/inputnumber';
import { PasswordModule } from 'primeng/password';
import { FloatLabelModule } from 'primeng/floatlabel';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { OnlyNumbersDirective } from '../only-numbers.directive';

@Component({
    selector: 'app-recovery-password',
    imports: [
      ReactiveFormsModule, FormsModule, CommonModule,
      AuthCodeFormComponentUser, LoaderComponent,
      ToastModule, InputNumberModule, PasswordModule, FloatLabelModule,
      ButtonModule, InputTextModule, SelectModule, OnlyNumbersDirective
    ],
    templateUrl: './recovery-password.component.html',
    styleUrl: './recovery-password.component.scss',
    providers: [MessageService]
})
export class RecoveryPasswordComponent implements OnInit {
  recoveryForm!: FormGroup;
  passwordForm!: FormGroup;
  step = 1;
  enProceso = false;
  isSuccessMessage = true;
  hiddenPhone = '';
  show2FA = false;
  showResponse = false;
  tokenRecovery = '';
  messageModal = '';
  selectedLada = '+52';
  ladaOptions = [
    { label: '+52', value: '+52', flag: './assets/icons/mexico-flag-icon.svg' },
    { label: '+1', value: '+1', flag: './assets/icons/united-states-flag-icon.svg' }
  ];

  @Input() isExpired: boolean = false;
  @Input() client!: number;

  constructor(
    private router: Router,
    private userService: LoginServicesService,
    private titleService: Title,
    private themeService: ThemeService,
    private messageService: MessageService
  ) {
    this.titleService.setTitle("Recuperación de contraseña");
    this.themeService.setTitle("Recuperación de Contraseña");
  }

  ngOnInit(): void {
    this.recoveryForm = new FormGroup({
      clientNumber: new FormControl(null, Validators.required),
      phoneNumber: new FormControl({ value: '', disabled: true }, [Validators.required]),
    });
    this.passwordForm = new FormGroup({
      newPassword: new FormControl('', [Validators.required, passwordStrengthValidator]),
      confirmPassword: new FormControl('', [Validators.required]),
    });
    if (this.client > 0) {
      this.recoveryForm.controls['clientNumber'].setValue(this.client);
    }
  }

  get passwordFormField() { return this.passwordForm.get('newPassword'); }
  get confirmPasswordFormField() { return this.passwordForm.get('confirmPassword'); }
  get clientNumber() { return this.recoveryForm.controls['clientNumber'] as FormControl; }
  get phoneNumber() { return this.recoveryForm.controls['phoneNumber'] as FormControl; }

  nextStep() {
    if (this.step === 1) {
      if (this.recoveryForm.controls["clientNumber"].errors) {
        this.showError("El número de cliente es requerido");
        return;
      }
      this.enProceso = true;
      this.userService.recoveryPhone(this.clientNumber.value).subscribe({
        next: (resp: any) => {
          this.enProceso = false;
          if (resp.error) {
            this.showError(resp.error);
          } else {
            this.phoneNumber.enable();
            this.step++;
            this.hiddenPhone = resp.phone;
            this.phoneNumber.addValidators([Validators.required, Validators.minLength(10)]);
          }
        },
        error: () => {
          this.enProceso = false;
          this.showError('Verifique la información e intente de nuevo');
        }
      });
    } else if (this.step === 2) {
      if (!this.recoveryForm.valid) {
        this.showError("Ingresa un no. de teléfono válido");
        return;
      }
      this.enProceso = true;
      this.userService.validatePhoneNumber(this.clientNumber.value, this.phoneNumber.value, !this.isExpired, this.selectedLada).subscribe({
        next: (resp: any) => {
          this.enProceso = false;
          if (resp.error) {
            this.show2FA = false;
            this.showError(resp.error);
          } else {
            this.show2FA = true;
          }
        },
        error: () => {
          this.enProceso = false;
          this.showError('Hubo un problema para validar tu no. de teléfono');
        }
      });
    }
  }

  backStep() {
    if (this.step === 1) {
      this.router.navigate(['login']);
      return;
    }
    if (this.step === 2) {
      this.phoneNumber.clearValidators();
      this.hiddenPhone = '';
    }
    this.step--;
  }

  saveNewPassword() {
    this.enProceso = true;
    this.userService.saveNewPassword(this.clientNumber.value, this.passwordFormField!.value, this.tokenRecovery, "", !this.isExpired).subscribe({
      next: (resp: any) => {
        this.enProceso = false;
        if (resp.isValid) {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: resp.message, life: 3000 });
          setTimeout(() => this.router.navigate(['/login']), 2000);
        } else {
          this.showError(resp.message);
        }
      },
      error: (err: any) => {
        this.enProceso = false;
        this.showError(err.error?.error || 'Error al guardar la contraseña');
      }
    });
  }

  validateOTP(resp: any) {
    this.step = resp.step;
    if (this.step === 2) {
      this.show2FA = false;
      if (!resp.success) {
        this.showError('No se pudo generar la recuperación de contraseña, intenta de nuevo');
      } else {
        this.step++;
        this.tokenRecovery = resp.msg;
      }
    }
  }

  redirectToLogin() {
    this.router.navigate(['/login']);
  }

  private showError(msg: string) {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: msg, life: 5000 });
  }
}
